import jQuery from 'jquery';
let $ = jQuery;

/**
* class HSN.ResponsiveCells
*
* Provides the functions to make CMS content cells responsive.
**/
HSN.ResponsiveCells = function (config) {
    /**
        * new HSN.ResponsiveCell(config)
        * - config (Object): A configuration object for the [[HSN.ResponsiveCell]
        **/
    var scope = this;

    config = (config = config || {});

    // Get Mobile Info if available
    if (window.HSN) {
        var deviceInfo = HSN.Instance().DeviceInformation;
        if (deviceInfo) {
            if (deviceInfo.IsMobile && !deviceInfo.IsTablet)
                this.showPhone = true;
        }
    }

    scope.HandleWindowResize();
    scope.TextResize('.TextContainer', '.rText');
    scope.ButtonResize('.rButton', '.rText');

    // Setup watcher
    $(window).resize(function () {
        scope.HandleWindowResize(false);
        scope.TextResize('.TextContainer', '.rText');
        scope.ButtonResize('.rButton', '.rText');
    });
    //}
};

HSN.ResponsiveCells.prototype = {
    showPhone: null,
    isFeatureCell: null,
    isSpotlight: null,
    /**
    * HSN.ResponsiveCell#HandleWindowResize(firstRun) -> void
    *
    * Handle window resizes and adjust the cell's contents.
    **/
    HandleWindowResize: function () {
        if (this.showPhone) {
            $('.YesPhone').show();
            $('.NoPhone').hide();

            $('.ResSwapper').each(function () {
                $(this).attr('src', $(this).data('src-mobile'));
            });
        }
        else {
            $('.YesPhone').hide();
            $('.NoPhone').show();

            $('.ResSwapper').each(function () {
                $(this).attr('src', $(this).data('src'));
            });
        }
    },
    TextResize: function (parents, children) {
        var isPersonalizedCell = $('#content-wrapper.personalized-cell').length;
        var isSpotlight = $('#content-wrapper .ResponsiveCard').length;
        $(parents + ' ' + children).each(function () {
            var me = $(this);
            if (isPersonalizedCell && isSpotlight) {
                me.css('font-size', '75px');
                me.css('line-height', '75px');
            }
            var myParents = me.parents(parents);
            // Get stored font size, or if this is our first run, get the current base css style font-size
            var fontSize = me.data('fs');
            if (!fontSize) {
                fontSize = parseInt(me.css('font-size'));
                me.data('fs', fontSize);
            }
            // If we have a lineheight, use that, else use the font-size
            var lineHeight = me.data('lh');
            if (!lineHeight) {
                lineHeight = parseInt(me.css('line-height'));

                if (isNaN(lineHeight) || lineHeight == '')
                    lineHeight = fontSize;

                me.data('lh', lineHeight);
            }
            // Font Sizes and Line Heights are set based on 1000px width base elements
            var factor = myParents.width() / 1000.0;
            this.style.fontSize = (parseFloat(fontSize) * factor) + 'px';
            this.style.lineHeight = (parseFloat(lineHeight) * factor) + 'px';
            this.style.visibility = 'visible';
        });
    },
    ButtonResize: function (parents, children) {
        $(parents + ' ' + children).each(function () {
            var me = $(this);
            var fontSize = parseInt(me.css('font-size'));
            var padX = fontSize / 2;
            var padY = fontSize;
            me.css('padding', padX + 'px ' + padY + 'px');
        });
    },
    StaticReRunDefault: function () {
        // Get Mobile Info if available
        if (this.showPhone === null && window.HSN) {
            var deviceInfo = HSN.Instance().DeviceInformation;
            if (deviceInfo) {
                if (deviceInfo.IsMobile && !deviceInfo.IsTablet)
                    this.showPhone = true;
            }
        }

        this.HandleWindowResize(false);
        this.TextResize('.TextContainer', '.rText');
        this.ButtonResize('.rButton', '.rText');
    }
};



// WEBPACK FOOTER //
// ./assets/js/HSN/ResponsiveCells.js